import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/blog/$id")({
  component: BlogPostRoute,
});

function BlogPostRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <BlogPost />
      </Suspense>
    </PageTransition>
  );
}
